import _ from 'lodash';
import qs from 'qs';

import globals from '../../components/PageBuilder/globals';
import api from '../../mdms_api';

export default async uuid => {
  const query = {};
  const { PB_ZONE } = globals();
  if (typeof window !== 'undefined') {
    query.lang = document.documentElement.getAttribute('locale');
    if (typeof PB_ZONE !== 'undefined') {
      query.zone = PB_ZONE;
    }
  }
  const response = await api.get(
    `/api/v2/product/shingles/${uuid}${_.isEmpty(query) ? '' : `?${qs.stringify(query)}`}`
  );
  return response.json();
};
